import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory, withRouter } from 'react-router';
import ShowCampaigns from '../../../components/logging/campaigns/ShowCampaigns';
import { fetchCampaignLogs, clearAuthErrors, clearLoggingErrors } from '../../../actions';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import Pagination from '../../../components/home/Pagination';
import TextField from 'material-ui/TextField';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  logs: PropTypes.any,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
};

class CampaignsPage extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  // TODO: review this, why duplication on each Container - gabo
  getChildContext() {
    return {
      muiTheme: getMuiTheme(baseTheme),
    };
  }
  componentWillMount() {
    this.props.dispatch(clearLoggingErrors());
    if (!this.props.isAuthenticated) {
      this.props.dispatch(clearAuthErrors());
      browserHistory.goBack();
    }
    const query = this.props.query;
    const router = this.props.router;
    if (this.props.logs.search && this.props.logs.search.length > 0) {
      query.search = this.props.logs.search;
    }
    if (!query.page) {
      query.page = 1;
      router.push({ pathname: '/logging/campaigns', query });
    } else {
      this.props.dispatch(fetchCampaignLogs(query));
    }
  }
  handleSearchChange(e) {
    const logs = this.props.logs;
    const query = this.props.query;
    const router = this.props.router;
    const nextName = e.target.value;
    logs.search = nextName;
    this.setState({
      logs,
    });
    if (nextName.length > 0) {
      query.search = nextName;
    } else {
      delete query.search;
    }
    query.page = 1;
    router.push({ pathname: '/logging/campaigns', query });
    this.props.dispatch(fetchCampaignLogs(query));
  }
  navigation(route) {
    // add search to url
    this.props.dispatch(fetchCampaignLogs(route));
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '1%',
      },
    };
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="log component" style={authPage}>
        <h2>Campaign Logging</h2>
        <div className="content">
          <div className="action-buttons top">
            <TextField
              floatingLabelText="Search by Email/Source"
              floatingLabelStyle={styles.floatingLabelStyle}
              inputStyle={styles.inputStyle}
              value={this.props.logs.search}
              onChange={this.handleSearchChange}
            />
            <Pagination
              paginationInfo={this.props.logs.meta}
              pageCall={route => this.navigation(route)}
            />
          </div>
          <hr />
          <ShowCampaigns
            logs={this.props.logs.results}
          />
        </div>
        <div className="action-buttons bottom">
          <Pagination
            paginationInfo={this.props.logs.meta}
            pageCall={route => this.navigation(route)}
          />
        </div>
      </div>
    );
  }
}

CampaignsPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

CampaignsPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    logs: state.logs,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(CampaignsPage));



// WEBPACK FOOTER //
// ./src/containers/logging/campaigns/CampaignsPage.js